import { HTTP_METHODS } from "constant/http";
import requestApi from "./requestApi";
import requestApiFile from "./requestApiFile";

const authApi = {
  registerEmail(body) {
    return requestApi("/auth/register/check-email", HTTP_METHODS.POST, body);
  },
  register(body) {
    return requestApi("/auth/register", HTTP_METHODS.POST, body);
  },
  login(body) {
    return requestApi("/auth/login", HTTP_METHODS.POST, body);
  },
  logout() {
    return requestApi("/auth/logout", HTTP_METHODS.GET);
  },
  verifyToken() {
    return requestApi("/auth/verify-token", HTTP_METHODS.GET);
  },
  forgotPassword(body) {
    return requestApi("/auth/forgot-password", HTTP_METHODS.POST, body);
  },
  resetPassword(body) {
    return requestApi("/auth/reset-password", HTTP_METHODS.POST, body);
  },
};

const profileApi = {
  getProfile() {
    return requestApi("/profile/get", HTTP_METHODS.GET);
  },
  editProfile(body) {
    return requestApi("/profile/edit", HTTP_METHODS.PUT, body);
  },
};

const fileApi = {
  uploadFile(body) {
    return requestApiFile("/file/upload", HTTP_METHODS.POST, body);
  },
};

const eventApi = {
  companyVisitCheck() {
    return requestApiFile("/company-visit/check", HTTP_METHODS.GET);
  },
  companyVisitRegister(body) {
    return requestApiFile("/company-visit/register", HTTP_METHODS.POST, body);
  },
  MCCCheck() {
    return requestApiFile("/mini-case-competition/check", HTTP_METHODS.GET);
  },
  MCCRegister(body) {
    return requestApiFile("/mini-case-competition/register", HTTP_METHODS.POST, body);
  },
  seminarCheck() {
    return requestApiFile("/seminar/check", HTTP_METHODS.GET);
  },
  seminarRegister(body) {
    return requestApiFile("/seminar/register", HTTP_METHODS.POST, body);
  },
  jobExpo() {
    return requestApiFile("/job-expo/jobs", HTTP_METHODS.GET);
  },
  jobExpoDetail(id) {
    return requestApiFile(`/job-expo/jobs/${id}`, HTTP_METHODS.GET);
  },
};

const actionApi = {
  ...authApi,
  ...profileApi,
  ...fileApi,
  ...eventApi,
};

export default actionApi;
